// extracted by mini-css-extract-plugin
export default {"link":"style-module--link--1ea7a","description":"style-module--description--c3034"};